<template>
    <div class="col-12">
        <div v-if="loading" class="text-center pb-4">
            <div class="spinner-border" role="status"></div>
        </div>

        <div v-else-if="informeData && informeData.resultado">
            <div class="card">
                <div class="card-header">
                    <h5 class="mb-0">Informe Spam</h5>
                </div>
                <div class="card-body">
                    <div class="mb-4">
                        <strong>Puntuación total</strong>
                    </div>
                    
                    <b-row class="mb-4 align-items-center">
                        <b-col cols="12" md="4">
                            <div class="card bg-light">
                                <div class="card-body text-center">
                                    <h1>{{ informeData.resultado.score }}</h1>
                                </div>
                            </div>
                        </b-col>
                        <b-col cols="12" md="8">
                            <div v-if="informeData.resultado.mensaje" :style="{ backgroundColor: informeData.resultado.color }" class="p-2">
                                <b class="white">{{ informeData.resultado.mensaje }}</b>
                            </div>
                        </b-col>
                    </b-row>
                    
                    <div v-if="informeData.resultado.reglas && informeData.resultado.reglas.length > 0">
                        <h6>Reglas</h6>
                        <b-table
                            hover
                            :items="informeData.resultado.reglas"
                            :fields="fields"
                            responsive
                            class="mt-2"
                        />
                    </div>
                </div>
            </div>
        </div>

        <div v-else>
            <div class="alert alert-warning">
                <p>No hay datos disponibles</p>
            </div>
        </div>
    </div>
</template>

<script>
    import apiComunicados from '../../../../services/api-comunicados';

    export default{
        props:{
            comunicado: {
                type: [String, Number],
                required: true
            }
        },
        data() {
            return {
                informeData: null,
                loading: true,
                fields: [
                    { key: 'description', label: 'Descripción' },
                    { key: 'score', label: 'Puntuación', class: 'text-center'  }
                ]
            }
        },  
        methods:{
            async getInformeSpam(comunicado)
            {
                try {
                    this.loading = true;
                    const response = await apiComunicados.getInformeSpam(comunicado);
                    this.informeData = response;
                } catch (error) {
                    this.$toast?.error("Error al obtener informe de spam");
                } finally {
                    this.loading = false;
                }
            }
        },
        created() {
            this.getInformeSpam(this.comunicado);
        }
    }
</script>

<style scoped>
.display-4 {
    font-size: 3rem;
    font-weight: bold;
}
</style>